module.exports = __webpack_public_path__ + "static/media/gallery_add_grey.35d85b0e.svg";